import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import TabsDefaultExample from '../examples/TabsDefault';
import TabsCustomExample from '../examples/TabsCustom';
const TabsDefaultExampleSource = require('!!raw-loader!../examples/TabsDefault');
const TabsCustomExampleSource = require('!!raw-loader!../examples/TabsCustom');
const TabsPage = () => (<div>
        <Helmet title="Tabs"/>
        <h3>Tabs</h3>
        <div className="docs-example">
            <TabsDefaultExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{TabsDefaultExampleSource}</PrismCode>
        </pre>
        <h3>Custom tabs</h3>
        <div className="docs-example">
            <TabsCustomExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{TabsCustomExampleSource}</PrismCode>
        </pre>
    </div>);
export default TabsPage;
